export default __webpack_public_path__ + "static/media/Products.7e13bd7b.svg";